import React, {Fragment, useState} from 'react'
import styled from 'styled-components'
import ProgressIndicator from './progress-indicator'
import { TABLET } from '../../utilities/breakpoints'
import TableColumnLabel from '../ui/table-column-label'
import { getThemeStyle } from '../../utilities/helpers'
import DriverStatBarSm from '../ui/driver-stat-bar-sm'
import ImportanceHearts from '../ui/importance-hearts'
import ThemeBadge from '../ui/theme-badge'
import Button from '../ui/button'
import StatementProgressCard from './statement-progress-card'
import { connect } from 'react-redux'
import { sortingService } from '../../utilities/sortingService'

const mapStateToProps = ({ survey: { prSortingType, sortAscending } }) => {
  return {
    prSortingType,
    sortAscending,
  };
};

const DriverProgressCard = ({
  index,
  driver,
  themeIndex = 0,
  showPrevious = false,
  showLabels = false,
  showThemeTitle = false,
  showNumbers = false,
  showStatements = false,
  mode = "list",
  progressSize = "md",
  useTranslate,
  prSortingType,
  sortAscending
}) => {

  const getSortedStatements = statements => {
    const sortedResults = [...statements];
    const sortingFunction = sortingService.getSortingFunction(prSortingType);
    return sortedResults.sort(sortingFunction(sortAscending));
  }

  const [showMore, setShowMore] = useState(false);

  return (
    <Wrapper className={`driver-progress-card ${showPrevious ? 'show-previous' : ''} ${mode}-mode`}>
      {showLabels && !showPrevious &&
        <LabelsRow className={"labels-row"}>
          <Columns progressSize={progressSize}>
            <TitleColumn>
              <TableColumnLabel className="label">{useTranslate('data_vault.label_driver')}</TableColumnLabel>
            </TitleColumn>
            <ProgressColumn>
              <TableColumnLabel className="label">{useTranslate('progress_reports.label_progress')}</TableColumnLabel>
            </ProgressColumn>
            <CurrentStateColumn>
              <TableColumnLabel className="label">{useTranslate('progress_reports.label_latest_current_state')}</TableColumnLabel>
            </CurrentStateColumn>
            <ImportanceColumn>
              <TableColumnLabel className="label">{useTranslate('progress_reports.label_latest_importance')}</TableColumnLabel>
            </ImportanceColumn>
          </Columns>
        </LabelsRow>
      }
      {showLabels && showPrevious &&
        <LabelsRow className={"labels-row"}>
          <Columns className={"with-button"} progressSize={progressSize}>
            <TitleColumn>
              <TableColumnLabel className="label">{useTranslate('data_vault.label_driver')}</TableColumnLabel>
            </TitleColumn>
            <ProgressColumn>
              <TableColumnLabel className="label">{useTranslate('progress_reports.label_progress')}</TableColumnLabel>
            </ProgressColumn>
            <CurrentStateColumn>
              <TableColumnLabel className="label">{useTranslate('progress_reports.label_latest')}</TableColumnLabel>
            </CurrentStateColumn>
            <ImportanceColumn>
              <TableColumnLabel className="label">{useTranslate('progress_reports.label_previous')}</TableColumnLabel>
            </ImportanceColumn>
            {showStatements &&
              <ButtonColumn></ButtonColumn>
            }
          </Columns>
        </LabelsRow>
      }
      <DriverCard>
        <Columns className={`columns ${showStatements ? "with-button" : ""}`} progressSize={progressSize}>
          <TitleColumn>
              <DriverTitle className={`${showThemeTitle ? "has-theme-title" : ""}`}>
                {(showThemeTitle && driver.catalystTitle.length > 0) &&
                  <ThemeBadge themeTitle={driver.catalystTitle} themeIndex={themeIndex} />
                }
                {(showNumbers && !showThemeTitle) &&
                  <DriverIndex style={{ backgroundColor: getThemeStyle(themeIndex).bgColor }}>
                    {showNumbers ? index + 1 : ''}
                  </DriverIndex>
                }
                <h5>{driver.title}</h5>
              </DriverTitle>
          </TitleColumn>
          <ProgressColumn>
            <TableColumnLabel className="label">{useTranslate('progress_reports.label_progress')}</TableColumnLabel>
            {showPrevious ?
              <ProgressIndicator
                resultProgress={driver.resultProgressSincePrevious}
                ratingProgress={driver.rateProgressSincePrevious}
                size={progressSize}
                vertical={true}
              />
              :
              <ProgressIndicator
                resultProgress={driver.resultProgressSincePrevious}
                ratingProgress={driver.rateProgressSincePrevious}
                size={progressSize}
                vertical={false}
              />
            }
          </ProgressColumn>
          <CurrentStateColumn>
            {showPrevious ?
              <Fragment>
                <TableColumnLabel className="label">{useTranslate('progress_reports.label_latest')}</TableColumnLabel>
                <div className="result-container">
                  <DriverStatBarSm result={driver.results[0].result} />
                  <span className="result">{driver.results[0].result !== null ? `${driver.results[0].result.toFixed(0)}%` : "-"}</span>
                </div>
                <div className="result-container" style={{marginTop: "5px"}}>
                  <ImportanceHearts importance={driver.results[0].rate} />
                  <span className="result">{driver.results[0].rate ? `${driver.results[0].rate.toFixed(1)}` : "-"}</span>
                </div>
              </Fragment>
              :
              <Fragment>
                <TableColumnLabel className="label">{useTranslate('progress_reports.label_latest_current_state')}</TableColumnLabel>
                <div className="result-container">
                  <DriverStatBarSm result={driver.results[0].result} />
                  <span className="result">{driver.results[0].result !== null ? `${driver.results[0].result.toFixed(0)}%` : "-"}</span>
                </div>
              </Fragment>
            }
          </CurrentStateColumn>
          <ImportanceColumn>
            {showPrevious ?
              <Fragment>
                <TableColumnLabel className="label">{useTranslate('progress_reports.label_previous')}</TableColumnLabel>
                <div style={{opacity: "0.6"}}>
                  <div className="result-container">
                    <DriverStatBarSm  result={driver.results[1].result} />
                    <span className="result">{driver.results[1].result !== null ? `${driver.results[1].result.toFixed(0)}%` : "-"}</span>
                  </div>
                  <div className="result-container" style={{marginTop: "5px"}}>
                    <ImportanceHearts importance={driver.results[1].rate} />
                    <span className="result">{driver.results[1].rate ? `${driver.results[1].rate.toFixed(1)}` : "-"}</span>
                  </div>
                </div>
              </Fragment>
              :
              <Fragment>
                <TableColumnLabel className="label">{useTranslate('progress_reports.label_latest_importance')}</TableColumnLabel>
                <div className="result-container">
                  <ImportanceHearts importance={driver.results[0].rate} />
                  <span className="result">{driver.results[0].rate ? `${driver.results[0].rate.toFixed(1)}` : "-"}</span>
                </div>
              </Fragment>
            }
          </ImportanceColumn>
          {showStatements &&
            <ButtonColumn>
              <Button
                kind={"gray"}
                className={"statements-button"}
                onClick={() => setShowMore(!showMore)}
              >
                {showMore ?
                  <svg width="41" height="26" viewBox="0 0 41 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M41.0002 0H18.1431V3.80952H41.0002V0Z" fill="black"/>
                    <path d="M41.0002 21.5864H18.1431V25.3959H41.0002V21.5864Z" fill="black"/>
                    <path d="M41.0003 10.7939H25.7622V14.6035H41.0003V10.7939Z" fill="black"/>
                    <path d="M14.3444 17.1613L2.8623 5.6792L0.168565 8.37294L11.6506 19.855L14.3444 17.1613Z" fill="black"/>
                    <path d="M2.69371 19.9899L14.1758 8.50781L11.482 5.81407L-2.58206e-05 17.2961L2.69371 19.9899Z" fill="black"/>
                  </svg>
                  :
                  <svg width="41" height="26" viewBox="0 0 41 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M40.9997 0H18.1426V3.80952H40.9997V0Z" fill="black"/>
                    <path d="M40.9997 21.5864H18.1426V25.3959H40.9997V21.5864Z" fill="black"/>
                    <path d="M40.9998 10.7939H25.7617V14.6035H40.9998V10.7939Z" fill="black"/>
                    <path d="M16.2381 10.7998H0V14.6093H16.2381V10.7998Z" fill="black"/>
                    <path d="M10 21.0379L10 4.7998L6.19048 4.7998L6.19048 21.0379L10 21.0379Z" fill="black"/>
                  </svg>

                }
                  </Button>
            </ButtonColumn>
          }
        </Columns>
        {showMore &&
          <StatementsContainer>
            <div className="driver-description">
              {driver.description}
            </div>
            <div className="statements">
              {getSortedStatements(driver.questionsStatistics).map((statement, index) => {
                return (
                  <StatementProgressCard
                    key={index}
                    index={index}
                    statement={statement}
                    useTranslate={useTranslate}
                    showLabels={index < 1}
                    showPrevious={true}
                    mode={"list"}
                  />
                )
              })}
            </div>
          </StatementsContainer>
        }
      </DriverCard>
    </Wrapper>
  )
}

export default connect(mapStateToProps)(DriverProgressCard);

const Wrapper = styled.div`
 + .driver-progress-card.card-mode {
  margin-top: 1rem;
 }
 
 + .driver-progress-card.list-mode {
  border-top: 1px solid #D7D7D7;
 }
`;

const LabelsRow = styled.div`
  width: 100%;
  display: none;
  
  @media${TABLET} {
    display: block;
    .card-mode & {
      margin-bottom: 10px;
      padding-right: 25px;
    }
  }
`;

const DriverCard = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding-top: 10px;
  padding-bottom: 10px;
  
  .card-mode & {
    border-radius: 10px;
    padding: 15px;
    box-shadow: 0 24px 64px rgba(0, 0, 0, 0.04);
  }
  
  .result-container {
    display: flex;
    align-items: center;
    
    .result {
      margin-left: 8px;
      font-size: 14px;
      font-weight: 500;
    }
  }
  
  .statement-stat-bar {
    width: 90px;
  }
  
  .columns .table-column-label {
    margin-bottom: 5px;
  }
  
  @media${TABLET} {
    align-items: center;
    padding-top: 15px;
    padding-bottom: 15px;
    
    .columns .table-column-label {
      display: none;
    }
    
    .card-mode & {
      border-radius: 10px;
      padding: 25px;
    }
  }
`;

const DriverTitle = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  
  &.has-theme-title {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  h5 {
    font-size: 18px;
    font-weight: 500;
    margin: 0;
  }
  
  @media${TABLET} {
    margin-bottom: 0;
    height: 100%;
  }
`;

const DriverIndex = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 100%;
  display: flex;
  flex: 0 0 20px;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 600;
  font-size: 13px;
  margin-right: 8px;
`;

const Columns = styled.div`
  @media${TABLET} {
    width: 100%;
    display: grid;
    grid-column-gap: 10px;
    align-items: center;
    
    ${props => props.progressSize === "sm" ? 
      'grid-template-columns: 1fr 140px repeat(2, 150px);'
      :
      'grid-template-columns: 1fr 150px repeat(2, 150px);'
    }
    
    &.with-button {
      grid-template-columns: 1fr 150px repeat(2, 150px) 50px;
    }
    
    .show-previous & {
      grid-template-columns: 1fr 100px repeat(2, 150px);
    }
    .show-previous &.with-button {
      grid-template-columns: 1fr 100px repeat(2, 150px) 50px;
    }
  }
 `;

const TitleColumn = styled.div``;

const ProgressColumn = styled.div`
  margin-bottom: 10px;
  
  @media${TABLET} {
    margin-bottom: 0;
  }
`;


const CurrentStateColumn = styled.div`
  margin-bottom: 10px;
  
  @media${TABLET} {
    margin-bottom: 0;
  }
`;

const ImportanceColumn = styled.div`
  margin-bottom: 10px;
  
  @media${TABLET} {
    margin-bottom: 0;
  }
`;

const ButtonColumn = styled.div`
  width: 50px;
  .statements-button {
    padding: 14px;
    
    svg {
      width: 21px;
      height: auto;
    }
  }
`;

const StatementsContainer = styled.div`
  text-align: left;
  width: 100%;
  margin-top: 1.5rem;
  border: 1px solid #E6E9EF;
  border-radius: 10px;
  background-color: #fefefe;
  
  .driver-description {
    background-color: #F6F6F5;
    padding: 1rem 1.25rem;
    border-bottom: 1px solid #E6E9EF;
    border-radius: 10px 10px 0 0;
    font-weight: 500;
  }
  
  .statements {
    padding: 20px 25px 5px;
    
    .labels-row {
      margin-bottom: 0;
    }
  }
  
  @media${TABLET} {
    margin-left: auto;
    
    .driver-description {
      padding: 1.5rem 1.75rem;
    }
  }
`;


// WEBPACK FOOTER //
// ./src/components/progress-reports/driver-progress-card.js